import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { SunDim } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { getRedirectPath } from "@/lib/utils";

export function NotFoundPage() {
  const { t } = useTranslation();
  const redirectTo = getRedirectPath();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-4 p-4 lg:max-w-96">
        <Link to={redirectTo}>
          <SunDim className="h-12 w-12 text-primary" />
        </Link>
        <h1 className="text-center text-4xl font-bold">{t("404 Page Not Found")}</h1>
        <p className="text-balance text-center">{t("Sorry, we couldn't find the page you're looking for.")}</p>
        <Link to={redirectTo} className={buttonVariants({ className: "w-full" })}>
          {t("Return to dashboard")}
        </Link>
      </div>
    </div>
  );
}
